import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import Moment from 'moment';
import ScrollArea from 'react-scrollbar';
import Loader from './Loader';
import NoResults from './NoResults';

const renderRowQuestion = (question, match) => (
  <Link to={`${match.url}/faqs/${question.section_id}/perguntas/${question.id}`}>
    <div className="notice-wrapper">
      <img src={require('../../img/icon-notification-green.svg')} className="icon" alt=""/>
      <div className="notice-content">
        <p>{question.question}</p>
        <span className="notice-button">Responder</span>
      </div>
    </div>
  </Link>
);

const renderRowAnswer = (question, match) => (
  <Link to={`${match.url}/faqs/${question.section_id}/respostas/${question.id}`}>
    <div className="notice-wrapper">
      <img src={require('../../img/icon-notification-green.svg')} className="icon" alt=""/>

      <div className="notice-content">
        <p>{`Sua pergunta "${question.question}" `}<strong>foi respondida</strong></p>
        <span className="notice-button">Ver resposta</span>
      </div>
    </div>
  </Link>
);

@inject('QuestionNoticeStore', 'NotificationStore') @observer
export default class QuestionNotices extends Component {
  componentWillMount() {
    const { QuestionNoticeStore, NotificationStore } = this.props;
    QuestionNoticeStore.fetchData();
    setTimeout(() => NotificationStore.readNotifications('question'), 2000);
  }

  _getProps() {
    const { QuestionNoticeStore } = this.props;

    let questions, noResultText, renderRow;
    if (this.props.userCanAnswerQuestions) {
      questions = QuestionNoticeStore.unansweredQuestions;
      noResultText = "Não há perguntas no momento";
      renderRow = renderRowQuestion;
    }
    else {
      questions = QuestionNoticeStore.answeredQuestions;
      noResultText = "Não há respostas no momento";
      renderRow = renderRowAnswer;
    }
    return { questions, noResultText, renderRow };
  }

  render() {
    const { QuestionNoticeStore } = this.props;
    const { questions, noResultText, renderRow } = this._getProps();

    return (
      <ScrollArea style={{ height: 400 }} stopScrollPropagation={true}>
        { !QuestionNoticeStore.loaded && <Loader /> }

        { QuestionNoticeStore.loaded &&
          !questions.length &&
          <NoResults text={noResultText} /> }
        <ul className="notice-list">
        { questions.map(question => {
          return (
            <li key={question.id}>
              { renderRow(question, this.props.match) }
            </li>
          )
        })}
        </ul>
      </ScrollArea>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/notices/QuestionNotices.js